import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bs4grid";
import useAppState from "../../../StateMachine/useAppState";

const Unimpersonate = () => {
  const accountState = useAppState("account");
  const router = useAppState("router");

  useEffect(() => {
    accountState
      .undoImpersonate()
      .then(() => {
        window.location.reload();
      })
      .catch(() => {
        router.push("/");
      });
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <p>Returning to admin ..</p>
        </Col>
      </Row>
    </Container>
  );
};

export default Unimpersonate;
